var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c(_vm.componentID,{tag:"component",attrs:{"sala_type":_vm.sala_type,"platform_id":_vm.platform_id}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }